import { render, staticRenderFns } from "./MeetingCalendarSettings.vue?vue&type=template&id=beefedde&scoped=true&"
import script from "./MeetingCalendarSettings.vue?vue&type=script&lang=js&"
export * from "./MeetingCalendarSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beefedde",
  null
  
)

export default component.exports